/**
 * Ruler-matched scale for blueprint pages: 1 model-inch = 7.5 page-px at 96 DPI.
 * Derived from the reference ruler image: 438 px / 40 notches ≈ 10.95 px/in at
 * 150 DPI, converted to 96 DPI: 10.95 × (96/150) ≈ 7.01 px/in, tuned to 7.5
 * to match the ruler notch pixel size in rendered output.
 */
export const RULER_PAGE_PX_PER_MODEL_INCH = 7.5;

/**
 * Maximum fraction of the page width the content can occupy before scaling
 * down uniformly. 0.95 gives comfortable side margins while maximising the
 * visible area for wide content.
 */
export const MAX_WIDTH_FRACTION = 0.95;

/**
 * Maximum fraction of the page height the content can occupy before scaling
 * down uniformly. Keeps top labels and bottom dimension arcs from clipping on
 * tall panels.
 */
export const MAX_HEIGHT_FRACTION = 0.95;

/** Page width in CSS pixels at 96 DPI for letter landscape (11 inches). */
export const PAGE_WIDTH_PX = 11 * 96; // 1056

/**
 * Reference content width in domain inches. Panels at this width render text
 * at the default font factor. Larger panels get a proportionally higher factor
 * so text stays readable when zoomed out.
 */
export const REFERENCE_WIDTH = 100;
